module.exports = __webpack_public_path__ + "static/media/title.9bcb7bdf.webp";